namespace RioERP.Web.Enums {
    export enum PaymentStatus {
        Initiated = 0,
        FullyPaid = 1,
        PartiallyPaid = 2,
        Pending = 3,
        Failed = 4,
        Dropped = 5,
        UserCancelled = 6,
        Bounced = 6
    }
    Serenity.Decorators.registerEnumType(PaymentStatus, 'RioERP.Web.Enums.PaymentStatus');
}
